import { FaFacebook, FaTwitterSquare, FaInstagram } from 'react-icons/fa';

function Footer() {
    return (
        <div className='bg-slate-900 w-full py-8'>
            <div className='max-w-[1250px] min-h-[80px] mx-auto md:grid grid-cols-3 items-center'>
                <div className='col-span-2 md:grid grid-cols-2'>
                    <div className='md:border-r md:my-0 my-3'>
                        <h1 className='text-white font-bold text-center uppercase text-3xl'>webo solutions</h1>
                    </div>
                    <div className='text-[#b6b6b6] md:my-0 my-3 text-center md:border-r'>
                        <ul className='flex gap-5 justify-center'>
                            <li>About</li>
                            <li>Portfolio</li>
                            <li>Contact</li>
                        </ul>
                        <p>&copy; {new Date().getFullYear()} Hammad Arshad All Rights Reserved</p>
                    </div>

                </div>
                <div className='col-span-1 md:my-0 my-3'>
                    <ul className='flex gap-5 justify-center'>
                        <li>
                            <FaFacebook className='text-[#b6b6b6] text-2xl' />
                        </li>
                        <li>
                            <FaTwitterSquare className='text-[#b6b6b6] text-2xl' />
                        </li>
                        <li>
                            <FaInstagram className='text-[#b6b6b6] text-2xl' />
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    )
}

export default Footer